import { render, staticRenderFns } from "./CertificadoUniversidad.vue?vue&type=template&id=095f83a0"
import script from "./CertificadoUniversidad.vue?vue&type=script&lang=js"
export * from "./CertificadoUniversidad.vue?vue&type=script&lang=js"
import style0 from "./CertificadoUniversidad.vue?vue&type=style&index=0&id=095f83a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports